import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

import { AccountsItem } from '../type';

export interface FundRequest {
  companyId: string;
  startDate: string;
  endDate: string;
}

interface FundsOverview {
  displayAccounts: AccountsItem[];
  hiddenAccounts: AccountsItem[];
}

export const getFunds = ({ companyId, startDate, endDate }: FundRequest) => {
  return API.get<ResponseBaseWithData<FundsOverview>>(
    `/api/v3/companies/${companyId}/cashflow-overview/funds`,
    {
      params: {
        startDate,
        endDate,
      },
    },
  );
};
